import React, { Component } from "react";
import _ from "lodash";
import { getSideNameForOption } from "../common/sideNameBuilder";

class UserControls extends Component {
  scores = {
    "best-of-nine": ["9-0", "8-1", "7-2", "6-3", "5-4", "4-5", "3-6", "2-7", "1-8", "0-9"],
    "fast-4-set": ["4-0", "4-1", "4-2", "4-3", "0-4", "1-4", "2-4", "3-4"],

    "tournament-10": [
      "10-9",
      "9-10",
      "10-8",
      "8-10",
      "10-7",
      "7-10",
      "10-6",
      "6-10",
      "10-5",
      "5-10",
      "10-4",
      "4-10",
      "10-3",
      "3-10",
      "10-2",
      "2-10",
      "10-1",
      "1-10",
      "10-0",
      "0-10",
    ],
    "tournament-15": [
      "15-14",
      "14-15",
      "15-13",
      "13-15",
      "15-12",
      "12-15",
      "15-11",
      "11-15",
      "15-10",
      "10-15",
      "15-9",
      "9-15",
      "15-8",
      "8-15",
      "15-7",
      "7-15",
      "15-6",
      "6-15",
      "15-5",
      "5-15",
      "15-4",
      "4-15",
      "15-3",
      "3-15",
      "15-2",
      "2-15",
      "15-1",
      "1-15",
      "15-0",
      "0-15",
    ],
  };

  handleSubmit = (e) => {
    e.preventDefault();
  };

  render() {
    const matches = _.chain(this.props.matches).orderBy("score", "desc").orderBy("round", "desc").value();
    const { data, scoreTypeId, validNewRoundRequests } = this.props;

    return (
      <div className="container">
        <div className="row alight-items-start">
          {validNewRoundRequests.map((r) => (
            <div key={r.name} className="col">
              <button className="btn btn-primary btn-large" onClick={() => this.props.onNewRound(r)}>
                {r.name}
              </button>
            </div>
          ))}
        </div>
        <div className="row alight-items-start mt-2">
          <div className="col">
            <form onSubmit={this.handleSubmit}>
              <div className="form-group">
                <label htmlFor="matchId">Match:</label>
                <select id="matchId" className="form-select" value={data.matchId} onChange={(e) => this.props.onChange(e)}>
                  <option key="empty" value="">
                    Select a match
                  </option>
                  {matches.map((m) => (
                    <option key={m.matchId} value={m.matchId}>
                      {getSideNameForOption(m.side1)} {m.score || "vs"} {getSideNameForOption(m.side2)}
                    </option>
                  ))}
                </select>
              </div>
              <div className="form-group">
                <label htmlFor="scoreId">Score:</label>
                <select id="scoreId" className="form-select" value={data.scoreId} onChange={(e) => this.props.onChange(e)}>
                  <option key="empty" value="">
                    Select a score
                  </option>
                  {this.scores[scoreTypeId].map((s) => (
                    <option key={s} value={s}>
                      {s}
                    </option>
                  ))}
                </select>
              </div>
              <div className="form-group">
                <button className="btn btn-primary btn-large mt-2" onClick={() => this.props.onNewScore()}>
                  Set Score
                </button>
              </div>
            </form>
          </div>
        </div>
      </div>
    );
  }
}

export default UserControls;
